import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { TreeNode } from 'primeng/api';
import { isExportAssignment } from 'typescript';

import { ConstantsModule } from '../constants/constants.module';
import { DialogPage } from '../root_classes/dialog-page';

@Component({
	selector: 'app-folder-edit',
	templateUrl: './folder-edit.component.html',
	styleUrls: ['./folder-edit.component.scss']
})
export class FolderEditComponent extends DialogPage implements OnInit {

	// Form data.
	folderEditForm = new FormGroup({
		nameControl: new FormControl('', [Validators.required]),
		pathControl: new FormControl('', [Validators.required]),
		engineerControl: new FormControl('', [Validators.required]),
		endDateControl: new FormControl('', [Validators.required]),
	});

	// Datas list.
	public treeStructure: TreeNode[] = [];
	public selectedFolder: TreeNode = {};
	public engineersList: any[] = [];

	// Extra data.
	public folderId: string = "";
	public folderName: string = "";
	public buttonText: string;
	public enableAction: boolean;

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Save button infos.
		this.buttonText = "Enregistrer";
		this.enableAction = true;
	}

	ngOnInit(): void {
		this.put("/api/folder-browse-list", undefined, 
			(response: any) => {
				if (response.DATA == "ERR") {
					switch (response.VALUE) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
						break;
					case "TREE DATA RECOVERY":
						this.alertLine.alertDangerMessage = "Impossible de récupérer la liste des dossiers. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
						break;
					}
				} else {
					// Filling server folders tree.
					this.treeStructure = <TreeNode[]> response.RES;

					var newData = {
						"id": this.folderId
					};

					this.put("/api/folder-path", newData, 
						(response: any) => {
						if (response.DATA == "ERR") {
							switch (response.VALUE) {
							case "UNAUTHORIZED":
								this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
								break;
							case "DATABASE":
								this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
								break;
							case "NOT FOUND":
								this.alertLine.alertDangerMessage = "Impossible de trouver le dossier à éditer. Merci de recommencer l'opération.";
								break;
							default:
								this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
								break;
							}
						} else {
							this.folderEditForm.controls["pathControl"].setValue(response.RES);

							// Checking the selected path.
							for (var treeIndex in this.treeStructure) {
								this.findSelectedPath(response.RES, this.treeStructure[treeIndex]);
							}
						}
					},
					(err: any) => {
						// Cannot load the data.
						this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
					});
				}
			},
			(err: any) => {
				// Cannot load the data.
				this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
			}
		);

		this.put("/api/user-engineer-list", undefined,
			(response:any) => {
				if (response.DATA == "ERR") {
					switch (response.VALUE) {
						case "UNAUTHORIZED":
							this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
							break;
						case "DATABASE":
							this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
							break;
						default:
							this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
							break;
					}
				} else {
					this.engineersList = response.RES;
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
			}
		);

		// Loading the engineer (because of last minute modification).
		this.put("/api/folder-engineer", {"id":this.folderId},
			(response:any) => {
				if (response.DATA == "ERR") {
					switch (response.VALUE) {
						case "UNAUTHORIZED":
							this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
							break;
						case "DATABASE":
							this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
							break;
						default:
							this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
							break;
					}
				} else {
					this.folderEditForm.controls["engineerControl"].setValue(response.ID);
					var engineerFound = false;
					
					for (var idx in this.engineersList) {
						if (this.engineersList[idx]._id == response.ID) {
							engineerFound = true;
							break;
						}
					}
					
					if (!engineerFound) {
						this.engineersList.push({_id: response.ID, name: response.NAME});
					}
				}
			},
			(err:any) => {
				this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";

			}
		);
	}

  /**
   * Find selected server folder path in complete folder tree.
   * @param path 
   * @param node 
   */
  private findSelectedPath(path: string, node: TreeNode) {
	if (node.data === path) {
		this.selectedFolder = node;
	} else {
		if (node.children != undefined && node.children.length != 0) {
			for (const children of node.children) {
				this.findSelectedPath(path, children);
			}
		}
	}
  }

  	public nodeSelect(event: any): void {
		// Update the path form value.
		this.folderEditForm.controls['pathControl'].setValue(event.node.data);
	}

  public setModalOptions(data:any): void {
	// This indicates, it is used inside another window.
    this.folderId = data["id"];
	this.folderName = data["name"];
	this.folderEditForm.controls["nameControl"].setValue(data["name"]); 

	// TO REVIEW : le formatage de la date pose problème pour son initialisation.
	this.folderEditForm.controls["endDateControl"].setValue(data["endDate"]); 
  }

  public save(): void {
		// Disabling button.
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
			id: this.folderId,
			path: this.folderEditForm.controls['pathControl'].value,
			name: this.folderEditForm.controls['nameControl'].value,
			engineer: this.folderEditForm.controls["engineerControl"].value,
			endDate: this.folderEditForm.controls['endDateControl'].value,
		};

		this.put("/api/folder-edit", newData, 
			(response: any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					// Inserting the new element in the list.
					var newFolder = {
						id: this.folderId,
						path: response.PATH,
						name: newData["name"],
						endDate: response.ENDDATE,
						endDateVal: response.ENDDATEVAL
					};
					this.modalInstance.dismiss(newFolder);
				}
			},
			(err: any) => {
				this.modalInstance.close(err);
			}
		);
	}
}
